import type { AgentTeam } from "@albertine/types/openapi/lmt";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

/** Base UI Select values must be strings; null means unassigned. */
const NO_TEAM = "no-team";

type Props = {
    teams: AgentTeam[];
    value: string | null;
    onValueChange: (teamId: string | null) => void;
    id?: string;
    size?: "sm" | "default";
    "aria-label"?: string;
};

export function AgentTeamSelect({
    teams,
    value,
    onValueChange,
    id,
    size = "default",
    "aria-label": ariaLabel,
}: Props) {
    const items: Record<string, string> = { [NO_TEAM]: "Unassigned" };
    for (const team of teams) {
        items[team.id] = team.name;
    }

    return (
        <Select
            items={items}
            value={value ?? NO_TEAM}
            onValueChange={(next) =>
                onValueChange(next === NO_TEAM ? null : (next as string))
            }
        >
            <SelectTrigger
                id={id}
                size={size}
                className="w-full"
                aria-label={ariaLabel}
            >
                <SelectValue />
            </SelectTrigger>
            <SelectContent>
                <SelectItem value={NO_TEAM}>Unassigned</SelectItem>
                {teams.map((team) => (
                    <SelectItem key={team.id} value={team.id}>
                        {team.name}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
}

export function agentTeamLabel(
    teams: AgentTeam[],
    teamId: string | null | undefined,
): string {
    if (!teamId) return "Unassigned";
    return teams.find((team) => team.id === teamId)?.name ?? "Unassigned";
}
